module.exports = __webpack_public_path__ + "media/Images/SwirlBlue-1fe71713.svg";